import Layout from './Layout';
import Content from './Content';
import Header from './Header';

Layout.Content = Content;
Layout.Header = Header;

export default Layout;
